import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DocumentRevisionRow from './DocumentRevisionRow';
import { PsTable } from './table/PsTable';

export default class DocumentsTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_ESTADO')}</th>
                <th>{I18nUtils.tr('TR_NOMBRE_DOCUMENTO')}</th>
                <th>{I18nUtils.tr('TR_FECHA_DOCUMENTO')}</th>
                <th>{I18nUtils.tr('TR_CADUCIDAD')}</th>
                <th>{I18nUtils.tr('TR_ACCESO_FICHA')}</th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.renderHead()}>
                {
                    _.map(this.props.data, (object, i) =>
                        <DocumentRevisionRow key={i} revision={object} />,
                    )
                }
            </PsTable>
        );
    }

}

DocumentsTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
};

DocumentsTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentRevisionsTable.jsx